module.exports = __webpack_public_path__ + "img/logo_pracevpardubicich.646b4ea.svg";